import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';


const layout = window?.$environment?.CURRENT_LAYOUT;
const Select = lazy(() => import(`globalcomponents/UI/Select/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`);
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));
const Input = lazy(() => import(`globalcomponents/UI/Input/${layout}`));

const RenderComponent = ({
  values,
  handleEdit,
  validateForm,
  customProps,
  submitAction,
  cancelAction,
}) => {
  const { i18n } = useTranslation();

  return (
    <>
      {/* <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="eventId">
          {i18n.t('Events')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="eventId"
            onChange={(event) => handleEdit(event, { field: 'eventId' })}
            as={Select}
            placeholder={i18n.t('common.pleaseSelect')}
            value={values['eventId']}
            suggestions={customProps.eventsList || []}
            isClearable
          />
          <Message type="error" message={customProps.validationError} />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper> */}

      <FormStyle.default.FieldsWrapper className="csafield vertical">
        <Label variant="body1" htmlFor="severityId">
          {i18n.t('Severity')}
        </Label>
        <FormStyle.default.TextWrapper>
          <Field
            name="severityId"
            onChange={(event) => handleEdit(event, { field: 'severityId' })}
            as={Select}
            placeholder={i18n.t('common.pleaseSelect')}
            value={values['severityId']}
            suggestions={customProps.severityList || []}
            isClearable
          />
        </FormStyle.default.TextWrapper>
      </FormStyle.default.FieldsWrapper>
      <FormStyle.default.ButtonsWrapper className="vertical-button">
        <Button
          type="submit"
          label={i18n.t('common.view')}
          onClick={(e, d) => {
            const validateResponse = validateForm();
            validateResponse.then((data) => {
              submitAction(data);
            });
          }}
        />
        <Button
          className=""
          type={'reset'}
          label={i18n.t('common.clear')}
          onClick={() => {
            cancelAction();
          }}
        />
      </FormStyle.default.ButtonsWrapper>
    </>
  );
};

RenderComponent.propTypes = {
  values: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  isNotValid: PropTypes.bool.isRequired,
  hasApiStatus: PropTypes.object,
  validateForm: PropTypes.func.isRequired,
  submitAction: PropTypes.func.isRequired
};

export default RenderComponent;
